export const pushUnique2ObjectProp = (object, prop, item) =>
{
    if(Array.isArray(object[prop]))
        !object[prop].includes(item) && object[prop].push(item)
    else
        object[prop] = [item];
    return object
}
export function pushByComplexIndex (collection, indexProp, item)
{
    if(collection.length){
        collection.forEach((collItem,index, coll) => {
            const hasMatch = item[indexProp].find(
                indexPart => collItem[indexProp].includes(indexPart)
            );

            if(hasMatch){
                Object.keys(coll[index]).forEach( key => {
                    if(typeof coll[index][key][0] === 'object')
                        coll[index][key] = _.uniqBy([...coll[index][key], ...item[key]],'id')
                    else
                        coll[index][key] = _.uniq([...coll[index][key], ...item[key]])

                });
            }
            else
                coll.push(item);
        }) ;
    }
    else
        collection.push(item);

    return collection;
}

export const set2ObjectProp = (object, prop, prop2, value) =>
{
    if(!object)
        return

    if(!object.hasOwnProperty(prop))
        object[prop] = {}

    object[prop][prop2] = value

    return object
}
